import {
    SET_LISTINGS,
    SET_UNIT_REVIEWS,
    LOADING_LISTINGS,
    FAILED_LISTINGS,
} from '../actions/action-types';
import {SET_DESTINATION_INFOGRAPHIC} from '../modules/DestinationInfographic/redux.js';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_DESTINATION_INFOGRAPHIC:
            return {
                ...state,
                infographic: action.payload,
            };
        case SET_UNIT_REVIEWS:
            return {
                ...state,
                reviews: action.payload,
            };
        case SET_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    inventoryCount: action.inventoryCount,
                    loading: false,
                },
                segments: action.filterTags,
                listings: action.listings,
                lastCardUrl: action.lastCardUrl,
                cachedListings: action.cachedListings,
            };
        case LOADING_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    failed: false,
                    loading: true,
                    key: action.segmentKey,
                    timeoutMs: action.timeoutMs,
                },
            };
        case FAILED_LISTINGS:
            return {
                ...state,
                segmentFilters: {
                    ...state.segmentFilters,
                    loading: false,
                    failed: true,
                    timeoutMs: state.segmentFilters.timeoutMs * 2,
                },
            };
        default:
            return state;
    }
};
